export class Address {
    province: string;
    city: string;
    post_code: string;
    street_type: string;
    street_name: string;
    additional_info: string;
    street_number: string;
    staircase_number: string;
    floor_number: string;
    apartment_number: string;
}
